import { LOGOS, NAV, FOOTER_NAV_IDS, FDP_ID, BROCHURE_URL, scrollToId } from "@/data/site";
import { FileText } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useI18n();
  const links = NAV.filter((l) => FOOTER_NAV_IDS.includes(l.id));
  return (
    <footer className="bg-navy-deep">
      <div className="container-site section-pad py-14">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-md">
            <div className="mb-5 flex items-center gap-2">
              <div className="flex h-9 items-center justify-center rounded-md bg-white px-1.5">
                <img src={LOGOS.iem} alt="IEM logo" className="h-6 w-auto object-contain" />
              </div>
              <div className="flex h-9 items-center justify-center rounded-md bg-white px-1.5">
                <img src={LOGOS.uem} alt="UEM logo" className="h-6 w-auto object-contain" />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <span className="gold-rule" aria-hidden="true" />
              <span className="text-xs font-semibold uppercase tracking-[0.24em] text-gold-soft">{t.hero.scheme}</span>
            </div>
            <h3 className="font-display mt-4 text-xl leading-snug text-primary-foreground">{t.hero.title}</h3>
            <p className="mt-4 text-sm text-primary-foreground/60">{t.hero.dates}</p>
            <p className="text-sm font-medium text-gold-soft">{FDP_ID}</p>
            <a
              href={BROCHURE_URL}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="mt-5 inline-flex items-center gap-2 rounded-md border border-primary-foreground/20 px-3.5 py-2 text-xs font-semibold text-primary-foreground/85 transition-colors hover:border-gold/50 hover:text-gold-soft"
            >
              <FileText className="h-3.5 w-3.5" /> {t.hero.brochure}
            </a>
          </div>

          <div className="flex flex-col gap-8 sm:flex-row sm:gap-16">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary-foreground/40">{t.footer.navigate}</p>
              <ul className="mt-4 space-y-2.5">
                {links.map((link) => (
                  <li key={link.id}>
                    <button onClick={() => scrollToId(link.id)} className="text-sm text-primary-foreground/70 transition-colors hover:text-gold-soft">
                      {t.nav[link.key]}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <div className="max-w-xs">
              <p className="text-xs font-semibold uppercase tracking-[0.18em] text-primary-foreground/40">{t.footer.hostedBy}</p>
              <p className="mt-4 text-sm leading-relaxed text-primary-foreground/70">{t.footer.iem}</p>
              <p className="mt-1 text-sm leading-relaxed text-primary-foreground/70">{t.footer.uem}</p>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-foreground/10 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-primary-foreground/45">{t.footer.copyright}</p>
          <p className="flex flex-wrap gap-x-2 text-xs text-primary-foreground/45">
            {links.map((link, i) => (
              <span key={link.id}>
                {t.nav[link.key]}
                {i < links.length - 1 ? " \u00b7" : ""}
              </span>
            ))}
          </p>
        </div>
      </div>
    </footer>
  );
};
